import { z } from "zod";

import { employeeSchema } from "../employees/schemas/baseEmployee";
import { schemes } from "../schema-validation";
import { baseEventInput } from "./baseEvent";

export const paycardOnboardingStatusEventPayloadSchema =
  employeeSchema.partial();

const contractorPaycardOnboardingStatusEvent = baseEventInput.merge(
  z.object({
    source: z.literal("contractors"),
    contractorId: schemes.mongoObjectId(),
    email: schemes.email(),
    companyId: schemes.uuid(),
    payload: z.object({
      hasKYCStatusChange: z.boolean().optional(),
      hasSSNVerificationStatusChange: z.boolean().optional(),
    }),
  })
);

const employeePaycardOnboardingStatusEvent = baseEventInput.merge(
  z.object({
    source: z.literal("employees"),
    employeeId: schemes.mongoObjectId(),
    email: schemes.email(),
    companyId: schemes.uuid(),
    payload: z.object({
      hasKYCStatusChange: z.boolean().optional(),
      hasSSNVerificationStatusChange: z.boolean().optional(),
    }),
  })
);

export const paycardOnboardingStatusEvent = z.discriminatedUnion("source", [
  contractorPaycardOnboardingStatusEvent,
  employeePaycardOnboardingStatusEvent,
]);

export type TContractorPaycardOnboardingStatusEvent = z.infer<
  typeof contractorPaycardOnboardingStatusEvent
>;
export type TEmployeePaycardOnboardingStatusEvent = z.infer<
  typeof employeePaycardOnboardingStatusEvent
>;
export type TPaycardOnboardingStatusEvent = z.infer<
  typeof paycardOnboardingStatusEvent
>;
